export enum DomainOrigin{
    Registration = 'user_registration',
    UpdateRegistration = 'user_update_registration',
    Mock = 'mock'
}